import { brand } from "../../../../config/theme";
import tw from "tailwind-styled-components";

export const FormContainer = tw.div`
w-full h-full overflow-auto
flex flex-col p-4 gap-4 relative
`;

export const Path = tw.div`
font-Roboto font-semibold 
text-sm text-gray-400
`;

export const ButtonsContainer = tw.div`
flex items-center justify-end gap-3
`;

export const Form = tw.form`
flex flex-col gap-4
`;

export const SectionsContainer = tw.div`
rounded-xl bg-white flex flex-col gap-5
shadow-gray-300 shadow-custom py-6 px-6
`;

export const Section = tw.div`
flex flex-col gap-4 w-auto px-1
`;

export const SectionTitle = tw.label`
w-full flex items-center justify-center gap-2
text-center text-sm font-bold font-Roboto text-[#757575]
relative
before:content-[''] before:flex-1 before:border-b-2 before:border-[#DFE5EF]
after:content-[''] after:flex-1 after:border-b-2 after:border-[#DFE5EF]
bg-transparent
`;

export const SectionContainer = tw.div`
grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-5 gap-y-4 mb-2
`;

export const ColumnContainer = tw.div`
grid grid-rows-3 gap-4
`;

export const InputContainer = tw.div`
flex flex-col gap-3
`;

export const InputLabel = tw.label`
font-semibold text-slate-900 text-base
`;

export const Input = tw.input`
border-2 py-2 focus:outline-none 
rounded-lg p-2 px-5 transition-colors
bg-white text-gray-900 border-[#DFE5EF] 
hover:border-primary-500 focus:border-primary-500
`;

export const Error = tw.label`
text-red-800 text-sm text-center
`;

export const Button = tw.button`
bg-primary-500 hover:bg-primary-400 text-white text-sm px-4 py-2 rounded-lg font-medium flex items-center space-x-2 transition-colors whitespace-nowrap
`;

export function selectStyles(isDarkMode: boolean) {
  return {
    control: (provided: any) => ({
      ...provided,
      cursor: "pointer",
      width: "100%",
      height: "2.75rem",
      border: isDarkMode ? "2px solid #4A4A4A" : "2px solid #DFE5EF",
      borderRadius: "0.5rem",
      boxShadow: "none",
      fontSize: "15px",
      marginLeft: 0,
      color: isDarkMode ? "#fff" : "#0C0A09",
      backgroundColor: isDarkMode ? "#232323" : "#fff",
      "&:hover": {
        borderColor: brand.primary,
      },
      "&:focus": {
        borderColor: brand.primary,
      },
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      cursor: "pointer",
      fontSize: "15px",
      color: isDarkMode ? "#fff" : "#0C0A09",
      backgroundColor: state.isFocused
        ? isDarkMode
          ? "#3A3A3A"
          : "#E3E8F0"
        : isDarkMode
        ? "#232323"
        : "#F3F4F6",
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: isDarkMode ? "#fff" : "#0C0A09",
    }),
    input: (provided: any) => ({
      ...provided,
      color: isDarkMode ? "#fff" : "#0C0A09",
    }),
    placeholder: (provided: any) => ({
      ...provided,
      color: isDarkMode ? "#bdbdbd" : "#616161",
    }),
  };
}
